import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-developer-import-status',
    templateUrl: './developer-import-status.component.html',
    styleUrls: ['./developer-import-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule]
})
export class DeveloperImportStatusComponent implements OnInit {
  formData: UntypedFormGroup;

  @Output() goRestart = new EventEmitter();

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.formData = this.buildForm();
  }

  buildForm(): UntypedFormGroup {
    return this.fb.group({
    });
  }

  restart(): void {
    this.goRestart.emit();
  }
}
